<img src="{{ imgUrl }}" alt="{{ altText }}" (click)="actionClicked()" title="{{ altText }}" />
